"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logger = void 0;
exports.setVerbose = setVerbose;
const logger_1 = require("@mytmpvpn/mytmpvpn-common/logger");
exports.logger = logger_1.Logger.create();
function setVerbose(verbose) {
    exports.logger.setLevel(verbose ? 'trace' : 'debug');
}
